<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <HeaderButtons :pageTitle="'注文情報'" :isShowCartButton="false" :isShowLoginButton="false" />
    </div>
    <div id="page-content" class="page-content">
      <h4 class="page-content__input-forms-title">■ お客様情報の入力</h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"
            ><span class="input-form__label-required">必須</span>お名前</label
          >
          <aside>
            <input
              type="text"
              id="name"
              name="name"
              v-model="applicant.name"
              @blur="validate()"
              placeholder="例：海野　太郎"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.applicant.name }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">お名前（フリガナ）</label>
          <aside>
            <input
              type="text"
              id="name_kana"
              name="name_kana"
              v-model="applicant.nameKana"
              @blur="validate()"
              placeholder="例：ウミノ　タロウ"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.nameKana
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"
            ><span class="input-form__label-required">必須</span>郵便番号</label
          >
          <aside>
            <input
              type="text"
              id="postal-code"
              name="postal-code"
              inputmode="numeric"
              v-model="applicant.postCode"
              @blur="validate()"
              placeholder="例：1010035"
              required
              class="input-form__textbox input-form__textbox--postcode"
            />
            <button
              id="convertAddressButton"
              @click="setAddressByPostcode"
              class="btn btn-secondary input-form__button-convert-address"
            >
              郵便番号から住所をセット
            </button>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.postCode
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"
            ><span class="input-form__label-required">必須</span>都道府県</label
          >
          <aside>
            <select
              id="address-level1"
              name="address-level1"
              v-model="applicant.prefecture"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--tiny"
            >
              <option value="">（選択）</option>
              <option v-for="pref in prefectures" v-bind:value="pref">{{ pref }}</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.prefecture
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"
            ><span class="input-form__label-required">必須</span>市区町村、丁目・番地</label
          >
          <aside>
            <input
              type="text"
              id="address-level2"
              name="address-level2"
              v-model="applicant.address1st"
              @blur="validate()"
              placeholder="例：千代田区神田紺屋町１３"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address1st
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など</label>
          <aside>
            <input
              type="text"
              id="address-line2"
              name="address-line2"
              v-model="applicant.address2nd"
              @blur="validate()"
              placeholder="例：サンビル4F"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.address2nd
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">
            <span class="input-form__label-required">必須</span>電話番号
          </label>
          <aside>
            <input
              type="text"
              id="tel"
              name="tel"
              v-model="applicant.tel"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：0352975656 ※ハイフンは不要"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.applicant.tel }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"
            ><span class="input-form__label-required">必須</span>e-mail（PC・携帯）</label
          >
          <aside>
            <input
              type="text"
              id="email"
              name="email"
              v-model="applicant.email"
              @blur="validate()"
              inputmode="email"
              placeholder="例：taro_umino@bsac.jp"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.applicant.email }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">納品希望日</label>
          <p class="input-form__label-title--submessage" style="margin: 0 0 0.5rem 0.5rem">
            ご発注を頂きました商品は、正午までの受付分はその日に発送致しますが、正午以降に頂きました商品は、翌営業日に発送致します。<br />
            商品の到着は天候、交通事情、運送状況、また運送会社によって変動する恐れがありますので予めご了承ください。
          </p>
          <aside class="input-form__date-wrapper">
            <select
              id="delivery-day-year"
              name="delivery-day-year"
              v-model="applicant.deliveryAtYear"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">年</option>
              <option v-for="year in years" v-bind:value="year">{{ year }}年</option>
            </select>
            <select
              id="delivery-day-month"
              name="delivery-day-month"
              v-model="applicant.deliveryAtMonth"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">月</option>
              <option v-for="month in months" v-bind:value="month">{{ month }}月</option>
            </select>
            <select
              id="delivery-day-day"
              name="delivery-day-day"
              v-model="applicant.deliveryAtDay"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">日</option>
              <option v-for="day in delivertyDays" v-bind:value="day">{{ day }}日</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.deliveryAt
          }}</span>
        </section>
      </div>
      <h4 class="page-content__input-forms-title">
        ■ お届け先情報の入力
        <span class="input-form__label--caution"> ※上記住所と異なる場合のみご入力ください。 </span>
      </h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">お名前</label>
          <aside>
            <input
              type="text"
              id="delivery-name"
              name="delivery-name"
              v-model="delivery.name"
              @blur="validate()"
              placeholder="例：海野　太郎"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.delivery.name }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">お名前（フリガナ）</label>
          <aside>
            <input
              type="text"
              id="delivery-name-kana"
              name="delivery-name-kana"
              v-model="delivery.nameKana"
              @blur="validate()"
              placeholder="例：ウミノ　タロウ"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.delivery.nameKana
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">郵便番号</label>
          <aside>
            <input
              type="text"
              id="delivery-postal-code"
              name="delivery-postal-code"
              v-model="delivery.postCode"
              @blur="validate()"
              inputmode="numeric"
              placeholder="例：1010035"
              required
              class="input-form__textbox input-form__textbox--postcode"
            />
            <button
              id="convertAddressButton"
              @click="setAddressByPostcodeDelivery"
              class="btn btn-secondary input-form__button-convert-address"
            >
              郵便番号から住所をセット
            </button>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.delivery.postCode
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">都道府県</label>
          <aside>
            <select
              id="delivery-address-level1"
              name="delivery-address-level1"
              v-model="delivery.prefecture"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--tiny"
            >
              <option value="">（選択）</option>
              <option v-for="pref in prefectures" v-bind:value="pref">{{ pref }}</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.delivery.prefecture
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">住所１</label>
          <aside>
            <input
              type="text"
              id="delivery-address-level2"
              name="delivery-address-level2"
              v-model="delivery.address1st"
              @blur="validate()"
              placeholder="例：千代田区神田紺屋町１３"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.delivery.address1st
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title">建物名など</label>
          <aside>
            <input
              type="text"
              id="delivery-address-line2"
              name="delivery-address-line2"
              v-model="delivery.address2nd"
              @blur="validate()"
              placeholder="例：サンビル4F"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.delivery.address2nd
          }}</span>
        </section>
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"> 電話番号 </label>
          <aside>
            <input
              type="text"
              id="delivery-tel"
              name="delivery-tel"
              v-model="delivery.tel"
              @blur="validate()"
              inputmode="tel"
              placeholder="例：0352975656 ※ハイフンは不要"
              required
              class="input-form__textbox"
            />
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.delivery.tel }}</span>
        </section>
      </div>
      <h4 class="page-content__input-forms-title">その他</h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <label for="name" class="input-form__label-title"> 備考 </label>
          <aside>
            <textarea
              type="text"
              id="remarks"
              name="remarks"
              v-model="applicant.remarks"
              @blur="validate()"
              required
              class="input-form__textarea"
            />
          </aside>
          <span class="input-form__label-validation-message">{{
            this.error.applicant.remarks
          }}</span>
        </section>
      </div>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/cart" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <router-link v-bind:disabled="!isSubmit" to="/payment" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              確認画面へ進む
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Core as YubinBangoCore } from 'yubinbango-core2';
import errorValues from 'constant/shopping-order/error-values';
import HeaderButtons from 'vues/shopping-order/components/parts/HeaderButtons';
import selectboxValues from 'utils/selectbox-values';
import selections from 'constant/selections';
import validations from 'utils/validations';

export default {
  /**
   * 次の画面に遷移する前に実行する
   */
  beforeRouteLeave(to, from, next) {
    this.validate();
    next(this.isSubmit); // 入力値検証がNGの場合は遷移できない
  },
  components: {
    HeaderButtons,
  },
  computed: {
    /**
     * お客様情報を取得する
     */
    applicant: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/applicant'];
      },
    },
    /**
     * お届け先情報を取得する
     */
    delivery: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/delivery'];
      },
    },
    /**
     * 納品日リストを取得する
     */
    delivertyDays: function () {
      return selections.days({
        year: this.applicant.deliveryAtYear,
        month: this.applicant.deliveryAtMonth,
      });
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.error.applicant.address1st === null;
      result &= this.error.applicant.address2nd === null;
      result &= this.error.applicant.deliveryAt === null;
      result &= this.error.applicant.email === null;
      result &= this.error.applicant.nameKana === null;
      result &= this.error.applicant.name === null;
      result &= this.error.applicant.postCode === null;
      result &= this.error.applicant.prefecture === null;
      result &= this.error.applicant.remarks === null;
      result &= this.error.applicant.tel === null;

      result &= this.error.delivery.name === null;
      result &= this.error.delivery.nameKana === null;
      result &= this.error.delivery.postCode === null;
      result &= this.error.delivery.prefecture === null;
      result &= this.error.delivery.address1st === null;
      result &= this.error.delivery.address2nd === null;
      result &= this.error.delivery.tel === null;

      // //console.log('result:' + JSON.stringify(this.error));
      if (result) this.saveDataInStore();
      return result;
    },
    /**
     * 月リストを取得する
     */
    months: function () {
      return selectboxValues.getMonths();
    },
    /**
     * 支払い方法リスト
     */
    payments: function () {
      return selections.payment.list;
    },
    /**
     * 都道府県リストを取得する
     */
    prefectures: function () {
      return selectboxValues.prefectures;
    },
    /**
     * 年リストを取得する
     */
    years: function () {
      return selections.scheduledYears();
    },
  },
  created() {
    this.error = Object.assign({}, errorValues.error);
    // this.applicant = this.$store.getters['shoppingOrder/applicant'];
    // this.delivery = this.$store.getters['shoppingOrder/delivery'];
    this.validate({ all: true });
  },
  data() {
    return {
      // applicant: null,
      // delivery: null,
      error: null,
    };
  },
  methods: {
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('shoppingOrder/setApplicant', this.applicant);
      this.$store.commit('shoppingOrder/setDelivery', this.delivery);
    },
    /**
     * 郵便番号から住所を取得する
     */
    getAddressByPostcode: async function (postcode) {
      let adr = { prefecture: null, address1st: null };
      await new YubinBangoCore(postcode, (address) => {
        adr.prefecture = address.region;
        adr.address1st = address.locality + address.street;
      });
      // 念のためスリープする
      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await sleep(300);
      return adr;
    },
    /**
     * 郵便番号から住所を取得しテキストボックスにセットする
     */
    setAddressByPostcode: async function () {
      let address = await this.getAddressByPostcode(this.applicant.postCode);
      this.applicant.prefecture = address.prefecture;
      this.applicant.address1st = address.address1st;
      this.validate();
    },
    /**
     * 緊急連絡先：郵便番号から住所を取得しテキストボックスにセットする
     */
    setAddressByPostcodeDelivery: async function () {
      let address = await this.getAddressByPostcode(this.delivery.postCode);
      this.delivery.prefecture = address.prefecture;
      this.delivery.address1st = address.address1st;
      this.validate();
    },
    /**
     * 入力値を検証する
     */
    validate: function () {
      /**
       * お客様情報・お名前
       */
      this.error.applicant.name = validations.validateChars({
        value: this.applicant.name,
        size: 50,
        requiredCheck: true,
      });
      /**
       * お客様情報・お名前（フリガナ）
       */
      this.error.applicant.nameKana = validations.validateChars({
        value: this.applicant.nameKana,
        size: 50,
        requiredCheck: false,
      });
      /**
       * お客様情報・郵便番号
       */
      this.error.applicant.postCode = validations.validateChars({
        value: this.applicant.postCode,
        size: 7,
        requiredCheck: true,
        numerickCheck: true,
      });
      /**
       * お客様情報・都道府県
       */
      this.error.applicant.prefecture = validations.validateChars({
        value: this.applicant.prefecture,
        size: 10,
        requiredCheck: true,
      });
      /**
       * お客様情報・住所１（市区町村、丁目・番地）
       */
      this.error.applicant.address1st = validations.validateChars({
        value: this.applicant.address1st,
        size: 100,
        requiredCheck: true,
      });
      /**
       * お客様情報・住所２（建物名など）
       */
      this.error.applicant.address2nd = validations.validateChars({
        value: this.applicant.address2nd,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お客様情報・電話番号
       */
      this.error.applicant.tel = validations.validateChars({
        value: this.applicant.tel,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: true,
      });
      /**
       * お客様情報・e-mail
       */
      this.error.applicant.email = validations.validateChars({
        value: this.applicant.email,
        size: 100,
        emailCheck: true,
        requiredCheck: true,
      });
      /**
       * お客様情報・納品希望日
       */
      this.error.applicant.deliveryAt = validations.validateDate({
        value: {
          year: this.applicant.deliveryAtYear,
          month: this.applicant.deliveryAtMonth,
          day: this.applicant.deliveryAtDay,
        },
        requiredCheck: false,
      });
      /**
       * お客様情報・納品希望日の未来日チェック
       */
      if (this.error.applicant.deliveryAt === null) {
        this.error.applicant.deliveryAt = validations.validateFutureDate({
          value: {
            year: this.applicant.deliveryAtYear,
            month: this.applicant.deliveryAtMonth,
            day: this.applicant.deliveryAtDay,
          },
        });
      }
      /**
       * お届け先情報・氏名
       */
      this.error.delivery.name = validations.validateChars({
        value: this.delivery.name,
        size: 50,
        requiredCheck: false,
      });
      /**
       * お届け先情報・氏名（フリガナ）
       */
      this.error.delivery.nameKana = validations.validateChars({
        value: this.delivery.nameKana,
        size: 50,
        requiredCheck: false,
      });
      /**
       * お届け先情報・郵便番号
       */
      this.error.delivery.postCode = validations.validateChars({
        value: this.delivery.postCode,
        size: 7,
        requiredCheck: false,
        numerickCheck: true,
      });
      /**
       * お届け先情報・都道府県
       */
      this.error.delivery.prefecture = validations.validateChars({
        value: this.delivery.prefecture,
        size: 10,
        requiredCheck: false,
      });
      /**
       * お届け先情報・住所１（市区町村、丁目・番地）
       */
      this.error.delivery.address1st = validations.validateChars({
        value: this.delivery.address1st,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お届け先情報・住所２（建物名など）
       */
      this.error.delivery.address2nd = validations.validateChars({
        value: this.delivery.address2nd,
        size: 100,
        requiredCheck: false,
      });
      /**
       * お届け先情報・電話番号
       */
      this.error.delivery.tel = validations.validateChars({
        value: this.delivery.tel,
        size: 20,
        numericHyphenCheck: true,
        requiredCheck: false,
      });
      /**
       * 備考
       */
      this.error.applicant.remarks = validations.validateChars({
        value: this.applicant.remarks,
        size: 500,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/big-radio.scss';
@import 'stylesheets/input-form-radio.scss';
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
</style>
